import { createReducer, on } from '@ngrx/store';
import { TimeDeviationDialogState } from './time-deviation-dialog.state';
import { timeDeviationDialogStateInitial } from './time-deviation-dialog.state.initial';
import { TimeDeviationDialogActions } from './time-deviation-dialog.actions';

/**
 * Reducer für den Time-Deviation-Dialog.
 */
export const timeDeviationDialogReducers = createReducer(
  timeDeviationDialogStateInitial,

  on(
    TimeDeviationDialogActions.open,
    (state): TimeDeviationDialogState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    TimeDeviationDialogActions.close,
    (state): TimeDeviationDialogState => ({
      ...state,
      isOpen: false,
    }),
  ),

);
